export { default } from './resolveProps';